<template>
  <!-- eslint-disable -->

  <div class="wrap">
    <!-- 1) INTRasasdasdasdasdasdasdasdadasdasdasdasdasdasdO -->
    <transition name="fade">
      <section v-if="showIntro" class="intro">
        <div ref="flashRef" class="intro__flash" />
        <div ref="vignetteRef" class="intro__vignette" />

        <div class="intro__sparks">
          <span v-for="n in 20" :key="n" class="spark" />
        </div>

        <div class="intro__card">
          <h1 ref="introTitle" class="intro__title shimmer">
            Estás a punto de vivir la magia de mis XV Años
          </h1>

          <p ref="introBody" class="intro__body">
            Prepárate para una experiencia especial que guardarás en el corazón ✨
          </p>

          <img
            ref="butterfly"
            src="@/assets/mon.png"
            class="mariposa-magica"
          />

          <button class="btn btn--primary btn--go" @click="startVideo" ref="goBtn">
            Comenzar
          </button>
        </div>

        <audio ref="introSound" :src="introSoundSrc" preload="auto"></audio>
      </section>
    </transition>

    <!-- 2) VIDEO -->
    <transition name="fade">
      <section v-if="showVideo" class="videoStage">
    <video
  ref="videoRef"
  class="videoStage__video"
  :src="videoSrc"
  autoplay
  playsinline
  webkit-playsinline
  @ended="handleVideoEnd"
></video>

        <button class="btn btn--skip" @click="skipVideo">
          Omitir
        </button>
      </section>
    </transition>
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'InvitacionIdiomaIntro',
  emits: ['termino-video'], // 🔥 IMPORTANTE

  props: {
    videoSrc: {
      type: String,
      default: () => require('@/assets/nicol.mp4'),
    },
    introSoundSrc: {
      type: String,
      default: () => require('@/assets/intro.mp3'),
    },
  },

  setup(props, { emit }) {

    const showIntro = ref(true)
    const showVideo = ref(false)

    const videoRef = ref(null)
    const introTitle = ref(null)
    const introBody = ref(null)
    const goBtn = ref(null)

    const startVideo = async () => {
      showIntro.value = false
      showVideo.value = true
      await nextTick()
      try {
        await videoRef.value?.play()
      } catch (e) {
        console.log(e)
      }
    }

    const handleVideoEnd = () => {
      goToCard()
    }

    const skipVideo = () => {
      try {
        videoRef.value?.pause()
      } catch (e) {
        console.log(e)
      }
      goToCard()
    }

    // 🔥 AQUÍ ESTÁ EL CAMBIO IMPORTANTE
    const goToCard = () => {
      showVideo.value = false

      // 👉 en vez de router → emit
      emit('termino-video')
    }

    onMounted(() => {
      gsap.from(introTitle.value, { opacity: 0, y: 20 })
      gsap.from(introBody.value, { opacity: 0, y: 20, delay: 0.2 })
      gsap.from(goBtn.value, { opacity: 0, y: 20, delay: 0.4 })
    })

    return {
      showIntro,
      showVideo,
      videoRef,
      introTitle,
      introBody,
      goBtn,
      startVideo,
      skipVideo,
      handleVideoEnd,
    }
  },
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700&family=Montserrat:wght@300;400;500&family=Dancing+Script:wght@700&display=swap');

/* WRAPPER */
.wrap { position: relative; min-height: 100vh; background: #03021b; }

/* TRANSICIONES */
.fade-enter-active, .fade-leave-active { transition: opacity .6s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; }
.rise-enter-active { transition: all .6s cubic-bezier(.2,.8,.2,1); }
.rise-enter-from { opacity: 0; transform: translateY(12px); }

/* INTRO */
.intro {
  position: fixed; inset: 0; display: grid; place-items: center;
  background-image:   linear-gradient(rgba(194, 157, 183, 0.7), rgba(218, 162, 206, 0.7)), 
  url('@/assets/fondito.jpg');
  z-index: 30; overflow: hidden;
}
.intro__vignette{ position:absolute; inset:0; pointer-events:none; background: radial-gradient(80% 60% at 50% 50%, rgba(0,0,0,0) 55%, rgba(0,0,0,.35) 100%); opacity:0; }
.intro__flash{ position:absolute; inset:-10%; background: linear-gradient(180deg, rgba(255,255,255,1), rgba(255,255,255,.7) 60%, rgba(255,255,255,0)); filter: blur(6px); opacity:0; pointer-events:none; }

.intro__sparks{ position:absolute; inset:0; overflow:hidden; pointer-events:none; }
.spark{ position:absolute; width:2px; height:2px; background:rgba(255,255,255,.9); border-radius:50%; top: calc(50% + (var(--i,0) * 1px)); left: calc(50% + (var(--j,0) * 1px)); animation: spark 3.6s linear infinite; opacity:.8; }
.spark:nth-child(odd){ filter: drop-shadow(0 0 6px rgba(255,255,255,.8)); }
@keyframes spark{ 0%{ transform: translate(-50vw, 30vh) scale(0.7); opacity:0;} 20%{ opacity:1;} 100%{ transform: translate(50vw, -40vh) scale(0); opacity:0;} }

.intro__card { width: min(760px, 92vw); border-radius: 28px; padding: 28px 26px 24px; text-align: center; position: relative; z-index: 1; }
.intro__title { font-family: 'Playfair Display', serif; font-size: clamp(1.45rem, 3.6vw, 2.25rem); color: #f9f9f9; line-height: 1.2; margin: 0 0 12px; perspective: 800px; display: inline-block; }
.intro__title .l{ display:inline-block; will-change: transform, filter, opacity; }

.intro__underline{ width: 60%; height: 3px; margin: 8px auto 16px; background: linear-gradient(90deg,#eeeeee,#dfcfcf); border-radius: 999px; transform: scaleX(1); }

.shimmer{ position: relative; overflow: hidden; }
.shimmer::after{ content:''; position:absolute; inset:0; background: linear-gradient(120deg, rgba(255,255,255,0) 30%, rgba(255,255,255,.6) 50%, rgba(255,255,255,0) 70%); transform: translateX(-120%); animation: sheen 3.2s ease-in-out 1.2s infinite; pointer-events:none; mix-blend-mode: screen; }
@keyframes sheen{ 0%{ transform: translateX(-120%); } 60%{ transform: translateX(120%); } 100%{ transform: translateX(120%); } }

.intro__body { font-family: 'Montserrat', sans-serif; color: #ffffff; font-size: 1rem; margin: 0 0 18px; }

/* Botones */
.btn { display: inline-flex; align-items: center; justify-content: center; gap: 10px; border-radius: 14px; padding: 12px 18px; border: 1px solid transparent; cursor: pointer; font-family: 'Montserrat', sans-serif; }
.btn--primary { background: rgb(215, 211, 214); color: #846581; }
.btn--primary:hover { filter: brightness(1.08); }
.btn--go{ margin-top: 4px; }

/* VIDEO */
.videoStage { position: fixed; inset: 0; z-index: 25; overflow: hidden; background: #000; display: grid; place-items: center; }
.videoStage__video { width: 100%; height: 100%; object-fit: contain; background: #000; }
.videoStage__overlay { position: absolute; inset: 0; background: linear-gradient(to bottom, rgba(0,0,0,.15), rgba(0,0,0,.35)); pointer-events: none; }
.btn--skip {
  position: absolute;
  right: 16px;

  /* 🔥 clave para celular */
  top: calc(env(safe-area-inset-top) + 16px);

  background: rgba(255,255,255,.9);
  border: 1px solid rgba(0,0,0,.06);
  color: #3d393b;
  padding: 10px 14px;
  border-radius: 999px;
  z-index: 50;
}.btn--skip:hover { filter: brightness(1.02); }

/* TARJETA */
.invitacion-container { display: flex; justify-content: center; align-items: center; min-height: 100vh;  background: rgb(254, 250, 255); background-size: cover; background-position: center; background-attachment: fixed; position: relative; overflow: hidden; }
.ramita { position: absolute; top: 50%; width: 120px; transform: translateY(-50%); z-index: 0; pointer-events: none; opacity: .85; }
.ramita.izquierda { margint-left:-50px; }
.ramita.derecha   { right: 0; transform: translateY(-50%) scaleX(-1); }

/* 👑 Corona bajo el título */
.corona-bajo-titulo{
  display: block;
  width: 90px;
  height: auto;
  margin-top:-90px;
  margin: 8px auto 10px;
  filter: drop-shadow(0 2px 4px rgba(0,0,0,.18));
  pointer-events: none;
}

.invitacion-card {
  position: relative; padding: 80px 20px; margin: 0 auto; border-radius: 0 80px 0 80px;
background-image: 
  linear-gradient(rgba(230, 172, 206, 0.365), rgba(218, 168, 196, 0.201)), 
  url('@/assets/fondoflores.jpg');  text-align: center; width: 100%; max-width: 380px; z-index: 1; animation: fadeIn 1s ease-out;
  box-shadow: 0 18px 40px rgba(61,57,59,.16);
}
.flores-decorativas { position: absolute; top: 0; right: 0; width: 80p  q23e444qx; height: 80px; background-repeat: no-repeat; opacity: 0.7; }
.titulo-principal { font-family: 'Dancing Script', cursive; font-size: 2.5rem; color: #ffffff; margin-bottom: .5rem; letter-spacing: 1px; }
.subtitulo        { font-family: 'british', sans-serif; margin-top: 20px; font-size: 1.8rem; color: #ffffff; margin-bottom: 1rem; font-weight: 600; }
.fecha            { font-family: 'Montserrat', sans-serif; font-size: 1.25rem; color: #f4f4f4; margin-bottom: 2rem; letter-spacing: 1px; }
.seccion-idiomas  { margin: 2rem 0; }
.instruccion      { font-family: 'Montserrat', sans-serif; font-size: 1rem; color: #ffffff; margin-bottom: 1.5rem; font-weight: 400; }
.opciones-idioma  { display: flex; flex-direction: column; gap: 1rem; }
.btn-idioma { display: flex; align-items: center; justify-content: center; gap: 12px; padding: 14px; font-size: 1rem; font-family: 'Montserrat', sans-serif; background: #fff; font-weight:600;border: 1px solid #ece5e7; border-radius: 12px; color: #5f4b32; cursor: pointer; transition: all .3s ease; width: 100%; max-width: 220px; margin: 0 auto; box-shadow: 0 4px 8px rgba(0,0,0,.05); }
.btn-idioma:hover { background: #f8e8e8; transform: translateY(-2px); box-shadow: 0 6px 12px rgba(0,0,0,.1); }
.sello-decorativo { width: 80px; height: auto; position: absolute; top: -40px; left: 50%; transform: translateX(-50%); filter: drop-shadow(0 2px 4px rgba(0,0,0,.2)); opacity: .9; z-index: 2; }
.sello-decorativo--dup { top: auto; bottom: -40px; }
@keyframes fadeIn { from {opacity:0} to {opacity:1} }

@media (max-width: 480px) {
  .invitacion-card { padding: 2rem 1rem; }
  .titulo-principal { font-size: 2rem; }
  .subtitulo { font-size: 2rem; }
  .fecha { font-size: 1.1rem; }
}
/* Solo añadí el estilo de la mariposa; conserva tus estilos existentes */
.mariposa-magica{
  position: absolute;
  top: -5px; left: 0;
  width: 56px;
  height: auto;
  opacity: 1;
  pointer-events: none;
  z-index: 6;
  filter: drop-shadow(0 6px 10px rgba(0,0,0,.25));
  transform: translate3d(0,0,0);
}
</style>
